import { useInfiniteQuery, useQuery } from "react-query";
import { api } from "utils/api";
import { useAuth } from "features/auth";
import { submissionKeys } from "./queryKeys";
import type {
  OpenCallSubmissionsRequest,
  OpenCallSubmissionsResponse,
} from "../types";

const getOpenCallSubmissions = (params: OpenCallSubmissionsRequest) =>
  api.post<OpenCallSubmissionsResponse>(`/open-call/submissions`, {
    body: JSON.stringify(params),
  });

const useOpenCallSubmissions = (params: OpenCallSubmissionsRequest) =>
  useInfiniteQuery(
    submissionKeys.list(params),
    ({ pageParam }) =>
      getOpenCallSubmissions({
        ...params,
        searchAfter: pageParam,
      }),
    {
      getNextPageParam: (lastPage) => lastPage.searchAfter,
    }
  );

// Signed in user - 100 Most Recent Submissions
const useMyOpenCallSubmissions = () => {
  const { user } = useAuth();
  const params = {
    createdByUserId: user?.id,
    perPage: 100,
    sort: ["createdAt desc"],
  };
  return useQuery(
    submissionKeys.list(params),
    () => getOpenCallSubmissions(params),
    {
      enabled: !!user?.id,
    }
  );
};

export { useOpenCallSubmissions, useMyOpenCallSubmissions };
